import { pickT } from "@repo/shared";
import type { FlowInstanceStatus, FlowProcessStop } from "@repo/shared/types";
import { T } from "./flow-stage-helper.i18n";

/**
 * The factual line under the flow title: what is happening and what comes
 * next, or — while the process is stopped — why it stopped.
 *
 * The stage and the reason are independent: an external-review rejection can
 * leave the flow standing in compliance review, so the stop is never inferred
 * from the stage.
 */
export function flowStageHelper(
  status: FlowInstanceStatus,
  stopped: FlowProcessStop | null,
  canReopen: boolean,
  language: string,
): string {
  const t = pickT(T, language);
  if (stopped) {
    const line = t.stopped[stopped.reason];
    return canReopen ? `${line} ${t.stoppedReopenHint}` : line;
  }
  return t.helper[status];
}
